import type { ReactNode } from 'react'
import { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { replace } from 'connected-react-router'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import ModalContext from 'contexts/ModalContext'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import CorporateEventPartnershipBanner from './CorporateEventLandingPage/CorporateEventPartnershipBanner'
import CorporateEventNavbar from './CorporateEventLandingPage/CorporateEventNavbar'

const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
`

interface Props {
  eventId: string
  regionCode: string
  children: ReactNode
}

function CorporateEventLayout({ eventId, regionCode, children }: Props) {
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const showModal = useContext(ModalContext)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isLoggedIn) {
      showModal<AccountAccessModalResult>(<AccountAccessModal />).then((result) => {
        if (!result?.loggedIn) {
          dispatch(replace(`/${regionCode}`))
        }
      })
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  return (
    <>
      <StickyHeader>
        <CorporateEventPartnershipBanner />
        <CorporateEventNavbar eventId={eventId} regionCode={regionCode} />
      </StickyHeader>
      {isLoggedIn && children}
    </>
  )
}

export default CorporateEventLayout
